import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  
  try {
    // If icon component is passed directly
    if (icon) {
      IconComponent = icon;
    } 
    // If icon name string is passed
    else if (name) {
      IconComponent = FiIcons[`Fi${name}`];
    }
  } catch (e) {
    console.error("Icon Error:", e);
    IconComponent = null;
  }

  return IconComponent ? React.createElement(IconComponent, props) : <FiAlertTriangle {...props} />;
};

export default SafeIcon;